export default "__VITE_ASSET__b0ec12ca__"